module.exports = __webpack_public_path__ + "customer1.png?50c0a3669b841d4db3a86a4e0a9d7c44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/customer1.png
// module id = 113
// module chunks = 0